import { render } from "./assessmentClearance.vue?vue&type=template&id=b003ba6a&scoped=true"
import script from "./assessmentClearance.vue?vue&type=script&lang=js"
export * from "./assessmentClearance.vue?vue&type=script&lang=js"

import "./assessmentClearance.vue?vue&type=style&index=0&id=b003ba6a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b003ba6a"]])

export default __exports__